(function () {
    'use strict';
    var m = angular.module('auth');
    m.controller('AuthController', ["$scope", "http", "oauthPopup", "path", "avananUserDao", "routeHelper", "$routeParams", "$location", "configDao", "trialExpiredModal", "feature", "$rootScope", function ($scope, http, oauthPopup, path, avananUserDao, routeHelper, $routeParams, $location, configDao, trialExpiredModal, feature, $rootScope) {
        $scope.path = path;
        var root = path('auth').ctrl('auth');
        $scope.error = {};
        $scope.page = $routeParams.page;
        if ($scope.page == 'password-reset') {
            var qs = $location.search();
            $scope.token = qs.token;
            if (_($scope.token).isUndefined()) {
                changePage('login');
            }
        }
        $scope.loginModel = {
            email: '',
            password: '',
            repeatPassword: ''
        };
        $scope.loginButtons = [
            {
                'class': 'google-button',
                image: root.img('google.jpg'),
                text: 'Login with Google',
                execute: function () {
                    oauthPopup('/auth/login_google');
                }
            },
            /*{
        'class': 'dropbox-button',
        image: root.img('dropbox.jpg'),
        text: 'Login with Dropbox',
        execute: function() {
            oauthPopup('/auth/login_dropbox');
        }
    }, */
            {
                'class': 'password-button',
                icon: 'fa-unlock-alt',
                text: 'Login with password',
                execute: function () {
                    changePage('password-login');
                }
            }
        ];
        if (!feature.checkpointTheme) {
            $scope.loginButtons.splice(1, 0, {
                'class': 'box-button',
                image: root.img('box.jpg'),
                text: 'Login with Box',
                execute: function () {
                    oauthPopup('/auth/login_box');
                }
            });
        }
        $scope.login = function () {
            $scope.error = {};
            if (!$scope.loginModel.email) {
                $scope.error.email = 'Please enter valid account email address and password';
                return;
            }
            if (!$scope.loginModel.password) {
                $scope.error.password = 'Password can not be empty';
                return;
            }
            avananUserDao.login($scope.loginModel.email, $scope.loginModel.password).then(function (response) {
                if (response.data && response.data.password_expired) {
                    return routeHelper.redirectTo('password-change');
                }
                return avananUserDao.current().then(function (response) {
                    if (response.data.hidden) {
                        return routeHelper.restoreRoute();
                    }
                    return configDao.getTrialExpirationDays().then(function (res) {
                        var trialExpirationDays = res.pocExpiresInDays;
                        if (res.deployment_mode === 'demo') {
                            trialExpirationDays = res.demoExpiresInDays;
                        }
                        if (trialExpirationDays < 0) {
                            avananUserDao.logout();
                            return trialExpiredModal.show().then(function () {
                                $rootScope.$broadcast('$logout', { reason: 'trial expired' });
                            });
                        }
                        return routeHelper.restoreRoute();
                    });
                });
            }, function (error) {
                $scope.error.email = error.data.message;
                $scope.error.password = error.data.message;
            });
        };
        $scope.restore = function () {
            $scope.error = {};
            if (!$scope.loginModel.email) {
                $scope.error.email = 'Please enter valid account email address';
                return;
            }
            avananUserDao.forgot($scope.loginModel.email).then(function () {
                changePage('email-sent');
            }, function (error) {
                $scope.error.email = error.data.message;
            });
        };
        $scope.back = function () {
            changePage('login');
        };
        $scope.restorePassword = function (event) {
            event.preventDefault();
            changePage('password-restore');
        };
        $scope.changePassword = function () {
            $scope.error = {};
            if (!$scope.loginModel.password) {
                $scope.error.password = 'Password should not be empty';
                return;
            }
            if ($scope.loginModel.repeatPassword != $scope.loginModel.password) {
                $scope.error.repeatPassword = 'Passwords do not match, please retry';
                return;
            }
            avananUserDao.reset($scope.token, $scope.loginModel.password).then(function () {
                changePage('password-login');
            }, function (error) {
                $scope.error.password = error.data.message;
            });
        };
        function changePage(newPage) {
            $scope.error = {};
            routeHelper.redirectTo('auth', { page: newPage }, {
                replace: true,
                reload: false,
                saveQueryString: true
            });
            $scope.page = newPage;
        }
        $scope.getTitle = function () {
            return {
                'login': 'Log In to Avanan',
                'password-login': 'Log In to Avanan',
                'password-restore': 'Forgot Password',
                'email-sent': 'Forgot Password',
                'password-reset': 'Password Reset'
            }[$scope.page];
        };
    }]);
}());